/**
 * @file sortingDirection.enum.tsx
 * @description
 * -----------------------------------------------------
 * Enum para definir la dirección de ordenamiento en los filtros
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-22
 * @author DLTCode
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

/* eslint-disable no-unused-vars */

export enum SortingDirection {
  ASC = "asc",
  DESC = "desc",
}
